import { render, staticRenderFns } from "./BannerPwa.vue?vue&type=template&id=6edb6f5b&scoped=true"
import script from "./BannerPwa.vue?vue&type=script&lang=ts"
export * from "./BannerPwa.vue?vue&type=script&lang=ts"
import style0 from "./BannerPwa.vue?vue&type=style&index=0&id=6edb6f5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb6f5b",
  null
  
)

export default component.exports